import { takeLatest, put, call } from "redux-saga/effects";
import { sagaActions } from "../../actions";
import {
  searchWorkflowConfiguration,
  searchWorkflowConfigurationCompleted,
} from "../../slices/workflow_configuration";
import { workflowsService } from "../../../../../src/core/workflows/workflows_service";

async function handleSearchWorkflowConfiguration({
  token = "",
  page,
  items,
  filters,
}) {
  return await workflowsService.adminListWorkflowConfigurations(
    page,
    items,
    filters
  );
}

function* listSearchWorkflowConfigurationSaga({ payload }) {
  try {
    yield put(searchWorkflowConfiguration({ term: payload.filters }));
    const workflowConfigurationData = yield call(
      handleSearchWorkflowConfiguration,
      payload
    );
    yield put(searchWorkflowConfigurationCompleted(workflowConfigurationData));
  } catch (error) {
    console.error(error.message);
  }
}

export function* searchWorkflowConfigurationWatcherSaga() {
  yield takeLatest(
    sagaActions.START_SEARCH_LIST_WORKFLOW_CONFIGURATION,
    listSearchWorkflowConfigurationSaga
  );
}
